import { useSidebarFloats } from '@affine/core/components/hooks/use-sidebar-floats';
import { useWorkspaceNavigationHost } from '@affine/core/components/root-app-sidebar/workspace-navigation-host';
import { WorkbenchService } from '@affine/core/modules/workbench/services/workbench';
import { useLiveData, useServiceOptional } from '@toeverything/infra';

/**
 * Where the automation settings pane opens: the active view's body beside the
 * docked sidebar (below the top bar), as /all opens beside the workspace
 * sidebar. A floating sidebar covers the view, so the pane covers the screen
 * there (null).
 */
export function useAutomationSettingsHost(): HTMLElement | null {
  const workbench = useServiceOptional(WorkbenchService)?.workbench;
  const view = useLiveData(workbench?.activeView$ ?? null);
  const host = useWorkspaceNavigationHost(view?.id ?? '');
  const floats = useSidebarFloats();
  return floats ? null : host;
}
